export default "__VITE_ASSET__bed16542__"